import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
import { RawFloorplanCaptureSchema } from '../entities/rawFloorplan.js';
export const GetRawFloorplanVisualizationUploadUrlBodySchema = z.object({});
export const GetRawFloorplanVisualizationUploadUrlHeadersSchema = ApiLambdalerAuthHeaderWithRequestActorSchema;
export const GetRawFloorplanVisualizationUploadUrlPathSchema = z.object({
    entityId: InspectionEntityCornSchema,
    inspectionId: InspectionCornSchema,
    captureId: RawFloorplanCaptureSchema.shape.captureId,
});
export const GetRawFloorplanVisualizationUploadUrlResponseSchema = z.object({
    fields: z.record(z.string(), z.string()),
    objectKey: z.string(),
    url: z.string(),
});
export const GetRawFloorplanVisualizationUploadUrlApiSchema = {
    body: GetRawFloorplanVisualizationUploadUrlBodySchema,
    params: GetRawFloorplanVisualizationUploadUrlPathSchema,
    headers: GetRawFloorplanVisualizationUploadUrlHeadersSchema,
    response: GetRawFloorplanVisualizationUploadUrlResponseSchema,
};
export const GetRawFloorplanVisualizationUploadUrlRequestSchema = GetRawFloorplanVisualizationUploadUrlBodySchema.merge(GetRawFloorplanVisualizationUploadUrlHeadersSchema).merge(GetRawFloorplanVisualizationUploadUrlPathSchema);
